module.exports = __webpack_public_path__ + "img/CellAnalyzer.3d738c76.png";